import bootLayout from 'static/script/app/boot/boot-layout';
import DetailedSearchUI from 'static/script/app/ui/detailed-search-ui';
import FormSelectUI from 'static/script/app/ui/form-select-ui';
import SelectOrInputTextUI from 'static/script/app/ui/select-or-input-text-ui';
import Toggle from 'static/script/app/ui/toggle';
import DataListUI from 'static/script/app/ui/datalist-ui';

module.exports = initData => {
    bootLayout(initData);
    DetailedSearchUI.attachTo('[data-detailed-search]');
    FormSelectUI.attachTo('[data-form-select]');
    SelectOrInputTextUI.attachTo('[data-detailed-search-area], [data-detailed-search-price]');
    Toggle.attachTo('[data-toggle]');
    DataListUI.attachTo('[data-datalist]');
};


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/pages/detailed-search.js